'use strict';

rentalProductsService.$inject = ["common", "$stateParams", "RentalProductOverview", "RentalProductOverviewItem", "RentalHistoryItem", "RentalHistoryDetail", "RentalHistoryStatusItem", "RentalProduct", "RentalProductCategory", "api", "$cacheFactory", "$q", "MediPimData", "RentalProductsOrder"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalProductsService = rentalProductsService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalProductsService(common, $stateParams, RentalProductOverview, RentalProductOverviewItem, RentalHistoryItem, RentalHistoryDetail, RentalHistoryStatusItem, RentalProduct, RentalProductCategory, api, $cacheFactory, $q, MediPimData, RentalProductsOrder) {
    var cache = $cacheFactory('rentalCategoriesCache');

    return {
        init: init,
        getRentalProducts: getRentalProducts,
        getRentalProductById: getRentalProductById,
        getNewOrderContactInfo: getNewOrderContactInfo,
        setNewOrderContactInfo: setNewOrderContactInfo,
        getNewOrderDeliveryInfo: getNewOrderDeliveryInfo,
        setNewOrderDeliveryInfo: setNewOrderDeliveryInfo,
        getRentalProductCategories: getRentalProductCategories,
        getRentalProductMedipimdata: getRentalProductMedipimdata,
        orderRentedProducts: orderRentedProducts,
        searchCities: searchCities,
        searchStreet: searchStreet,
        getRentalHistory: getRentalHistory,
        getHistoryById: getHistoryById,
        setHistoryRemark: setHistoryRemark,
        getHistoryStatuses: getHistoryStatuses,
        searchRentalOrders: searchRentalOrders
    };

    var newOrderContactInfo;
    var newOrderDeliveryInfo;

    function getNewOrderContactInfo() {
        return newOrderContactInfo;
    }

    function setNewOrderContactInfo(_newOrderContactInfo) {
        newOrderContactInfo = _newOrderContactInfo;
    }

    function getNewOrderDeliveryInfo() {
        return newOrderDeliveryInfo;
    }

    function setNewOrderDeliveryInfo(_newOrderDeliveryInfo) {
        newOrderDeliveryInfo = _newOrderDeliveryInfo;
    }

    function init() {
        return RentalProductOverview.create();
    }

    function getRentalProducts(sellerId, categoryId, model) {
        model.isLoading = true;
        return api.rentalProducts.getAll({ sellerId: sellerId, categoryId: categoryId ? categoryId : 0 }).$promise.then(function (response) {
            model.isLoading = false;
            model.products = _lodash2.default.map(response, function (i) {
                return RentalProductOverviewItem.create(i);
            });
            return model;
        });
    }
    function getRentalHistory(search) {
        return api.rentalHistory.search(search).$promise.then(function (response) {
            response.results = _lodash2.default.map(response.results, function (i) {
                return RentalHistoryItem.create(i);
            });
            return response;
        });
    }
    function getHistoryById(id) {
        return api.rentalHistoryDetail.getById({ id: id }).$promise.then(function (response) {
            return RentalHistoryDetail.create(response);
        });
    }
    function setHistoryRemark(id, version, remark) {
        return api.rentalHistoryRemark.set({
            id: id,
            version: version,
            remark: remark
        }).$promise.then(function (response) {
            return RentalHistoryDetail.create(response);
        });
    }
    function getHistoryStatuses() {
        return api.rentalHistoryStatus.getAll().$promise.then(function (response) {
            return _lodash2.default.map(response.results, function (i) {
                return RentalHistoryStatusItem.create(i);
            });
        });
    }
    function searchRentalOrders(search) {
        return api.rentalOrderSearch.execute(search).$promise;
    }
    function getRentalProductMedipimdata(productId) {
        return api.rentalProductMedipim.getMedipimData({ productId: productId }).$promise.then(function (response) {
            return MediPimData.create(response);
        });
    }

    function getRentalProductCategories(sellerId) {
        var cachedRentalCategories = cache.get('rentalCategoriesCache?sellerId=' + $stateParams.SellerId + '&lang=' + common.localization.getCurrentLanguage());
        if (cachedRentalCategories) {
            return $q.when(_lodash2.default.map(cachedRentalCategories, function (i) {
                return RentalProductCategory.create(i);
            }));
        } else {
            return api.rentalProductCategories.getAll({ sellerId: sellerId }).$promise.then(function (response) {
                cache.put('rentalCategoriesCache?sellerId=' + $stateParams.SellerId + '&lang=' + common.localization.getCurrentLanguage(), response);
                return _lodash2.default.map(response, function (i) {
                    return RentalProductCategory.create(i);
                });
            });
        }
    }

    function getRentalProductById(productId) {
        return api.rentalProduct.get({ productId: productId }).$promise.then(function (response) {
            return RentalProduct.create(response);
        });
    }

    function orderRentedProducts(rentalProduct, recommendedProducts, suggestedProducts, contactInfo, deliveryInfo) {
        var rentalProductsOrder = void 0;

        //filter the ordered products
        if (recommendedProducts || suggestedProducts) {
            recommendedProducts = recommendedProducts.filter(function (p) {
                return p.order === true;
            });
            suggestedProducts = suggestedProducts.filter(function (p) {
                return p.order === true;
            });

            recommendedProducts = recommendedProducts.map(function (p) {
                return p.toJSON();
            });
            suggestedProducts = suggestedProducts.map(function (p) {
                return p.toJSON();
            });

            //create a new rentalproductorder and add the info
            rentalProductsOrder = RentalProductsOrder.create({
                rentalProducts: [rentalProduct.toJSON()].concat(recommendedProducts, suggestedProducts),
                contactInfo: contactInfo,
                deliveryInfo: deliveryInfo
            });
        } else {
            rentalProductsOrder = RentalProductsOrder.create({
                rentalProducts: [rentalProduct.toJSON()],
                contactInfo: contactInfo,
                deliveryInfo: deliveryInfo
            });
        }

        return api.rentalProductsOrder.order(rentalProductsOrder).$promise.then(function (response) {
            return RentalProductsOrder.create(response, true);
        });
    }

    /* Products search home and fast order*/
    function searchCities(searchString) {
        return api.searchCities.execute({ name: searchString }).$promise.then(function (resource) {
            return resource.results;
        });
    }

    function searchStreet(searchString, postalLocalityId) {
        return api.searchStreet.execute({ name: searchString, postalLocalityId: postalLocalityId }).$promise.then(function (resource) {
            return resource.results;
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/rentalProductsService.js
// module id = 826
// module chunks = 0